import { memo } from 'react';
import useLocalStore from '../../../../hooks/useLocalStore';
import PropTypes from 'prop-types';
import FJBrushObjectEraseRight from '../view/FJBrushObjectEraseRight';
import { useSelector } from 'react-redux';

const FJBrushObjectEraseRightContainer = memo(function FJObjectEraseRightContainer({ isShow }) {
    useLocalStore();

    const isNotImage = useSelector(state => state.objectErase.inputImageInfo === null);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);

    return <FJBrushObjectEraseRight isShow={isShow} isNotImage={isNotImage} headerTabIndex={headerTabIndex} />;
});

FJBrushObjectEraseRightContainer.propTypes = {
    isShow: PropTypes.bool,
};

export default FJBrushObjectEraseRightContainer;
